/**
 * Feature Flags Persistence
 * Handles loading and saving feature flags to localStorage
 */

import { FeatureFlags } from '../../store/slices/uiSlice'

const FEATURE_FLAGS_STORAGE_KEY = 'interax_feature_flags'

/**
 * Load feature flags from localStorage
 */
export const loadFeatureFlagsFromStorage = (): Partial<FeatureFlags> | null => {
  if (typeof window === 'undefined') return null

  try {
    const stored = localStorage.getItem(FEATURE_FLAGS_STORAGE_KEY)
    if (!stored) return null

    const parsed = JSON.parse(stored) as Partial<FeatureFlags>
    return parsed
  } catch (error) {
    console.warn('Failed to load feature flags from localStorage:', error)
    return null
  }
}

/**
 * Save feature flags to localStorage
 */
export const saveFeatureFlagsToStorage = (flags: FeatureFlags): void => {
  if (typeof window === 'undefined') return

  try {
    localStorage.setItem(FEATURE_FLAGS_STORAGE_KEY, JSON.stringify(flags))
  } catch (error) {
    console.warn('Failed to save feature flags to localStorage:', error)
  }
}

/**
 * Clear feature flags from localStorage
 */
export const clearFeatureFlagsFromStorage = (): void => {
  if (typeof window === 'undefined') return

  try {
    localStorage.removeItem(FEATURE_FLAGS_STORAGE_KEY)
  } catch (error) {
    console.warn('Failed to clear feature flags from localStorage:', error)
  }
}
